<template>
  <div class="introduction-content4">
    <div class="title-container">
      <div class="title-text">公司文化</div>
      <div class="title-text-en">Corporate Culture</div>
      <div class="slogan">迅速反应、以变应变、马上行动、注重结果</div>
    </div>
    <div class="item-show-container">
      <div
        v-for="(item, index) in itemList"
        :key="index"
        class="item"
      >
        <div class="icon-container">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L9 17L4 12" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="content-container">
          <div class="title">
            <img src="@/assets/image/title-arrow.png" alt="arrow left" class="arrow-left" />
            <span class="title-text">{{ item.title }}</span>
            <img src="@/assets/image/title-arrow.png" alt="arrow right" class="arrow-right" />
          </div>
          <div class="subtitle">{{ item.subtitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroductionContent4',
  data() {
    return {
      itemList: [
        {
          title: '用户第一',
          subtitle: '全方位尊重用户服务用户',
        },
        {
          title: '诚实守信',
          subtitle: '绝不改任何一个后台数据',
        },
        {
          title: '公开透明',
          subtitle: '让用户清晰知道自己收益',
        },
        {
          title: '政策稳定',
          subtitle: '让用户清晰知道绝不搞夕令朝改儿戏市场自己收益',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.introduction-content4 {
  width: 100%;
  height: auto;
  margin-top: 80px;
  
  .title-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    
    .title-text {
      font-weight: 700;
      font-size: 32px;
      line-height: 1;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .title-text-en {
      font-weight: 500;
      font-size: 18px;
      line-height: 1.5;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-top: 12px;
    }
    
    .slogan {
      font-weight: 500;
      font-size: 26px;
      color: #FFFFFF;
      line-height: 30px;
      margin-top: 40px;
    }
  }
  
  .item-show-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 34px;
    margin-top: 25px;
    flex-wrap: wrap;
    
    .item {
      width: 558px;
      height: 145px;
      background: linear-gradient(89deg, #212A92 0%, rgba(135, 65, 209, 0.6) 100%);
      border-radius: 12px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 30px 25px;
      
      .icon-container {
        width: 47px;
        height: 47px;
        background: linear-gradient(180deg, #FF21FB 0%, #8964FF 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        
        svg {
          width: 30px;
          height: 30px;
        }
      }
      
      .content-container {
        width: 443px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-left: 18px;
        
        .title {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 8px;
          
          .arrow-left {
            width: 26px;
            height: 22px;
            transform: scaleX(-1);
            display: block;
          }
          
          .title-text {
            font-weight: 700;
            font-size: 26px;
            line-height: 26px;
            color: #FFFFFF;
            display: block;
          }
          
          .arrow-right {
            width: 26px;
            height: 22px;
            display: block;
          }
        }
        
        .subtitle {
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
